// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

//image resizer
function imageResizer(url, size) {
    let lastPeriod = url.lastIndexOf(".");
    return `${url.substring(0, lastPeriod)}_${size}${url.substring(lastPeriod)}`;
}

// https://stackoverflow.com/a/2901298/9009351
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// num
function price(amount) {
    return `${currency}${numberWithCommas(Math.round(amount / 100))}`;
}

//form validation
// https://stackoverflow.com/a/46181
function validateText(element, response) {
    if (element.value == "") {
        alert(response);
        element.classList.add("invalid");
        return false;
    } else {
        element.classList.remove("invalid");
        return true;
    }
}

function validateEmail(element, response) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(element.value).toLowerCase()) == false) {
        alert(response);
        element.classList.add("invalid");
        return false;
    } else {
        element.classList.remove("invalid");
        return true;
    }
}

function validatePasswords(element1, element2, response) {
    if (element1.value !== element2.value) {
        alert(response);
        element1.classList.add("invalid");
        element2.classList.add("invalid");
        return false;
    } else {
        element1.classList.remove("invalid");
        element2.classList.remove("invalid");
        return true;
    }
}

//check for array similarity
// https://stackoverflow.com/a/25926600
function findOne(haystack, arr) {
    return arr.some(function (v) {
        return haystack.indexOf(v) >= 0;
    });
}

//preload image
// https://stackoverflow.com/q/3646036
function preloadImage(url) {
    let img = new Image();
    img.src = url;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}


//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}

//append product
function appendProduct(selector, productIn, replace = false) {
    // create unique id for product
    const id = Date.now() + Math.floor(Math.random() * 1000);

    //if there is no correctVariant we are coming from the search, wishlist or related products section
    //set the first variant as correct
    if (productIn.correctVariant == null) {
        // find the first in stock variant (new arrival section, cooper wants all same color)
        if (window.location.pathname != "/" && window.location.pathname != "/collections/giving-back") {
            for (let i = 0; i < productIn.variants.length; i++) {
                if (productIn.variants[i].inventory > 0) {
                    productIn.correctVariant = productIn.variants[i];
                    break;
                }
            }
        }
        // if there is still no in stock variant select the next
        if (productIn.correctVariant == null) {
            productIn.correctVariant = productIn.variants[0];
        }
    }

    // global discount if not a discount AND not already updated for sale
    // the AND is important since domain aliasing it would happen twice if called on same product
    if (globalDiscount != 1 && productIn.handle != "gift-card" && !productIn.correctVariant.sale) {
        productIn.correctVariant.compare_at_price_real = productIn.correctVariant.compare_at_price;
        if (productIn.correctVariant.compare_at_price == null) {
            productIn.correctVariant.compare_at_price = productIn.correctVariant.price;
        }
        productIn.correctVariant.price *= globalDiscount;
        // don't modifty this variant again
        productIn.correctVariant.sale = true;
    }

    // desktop image
    function collectionItemVisualHero() {
        let html = "";

        // check if we have a lifestyle image to show on hover
        if (productIn.lifestyle) {
            html += `<style>#product${id} .collectionItemVisual::after {background-image: url(${imageResizer(productIn.lifestyle, "large")})}</style>`;
        }

        // when we sort the array above we also selected the correct variant, that's the image we want to show
        // collection page we need to show variant specific images, other pages don't matter
        if (productIn.correctVariant.featured_image) {
            html += `<img class="collectionItemVisualHero" src="${imageResizer(productIn.correctVariant.featured_image.src, "large")}">`;
        } else {
            html += `<img class="collectionItemVisualHero" src="${imageResizer(productIn.featured_image, "large")}">`;
        }

        return html;
    }

    // mobile swiper
    function collectionItemVisualSwiperSlides() {
        // if there is no featured image, we return the first image
        if (!productIn.correctVariant.featured_image) {
            return `<img class="collectionItemVisualSwiperImage swiper-slide" src="${imageResizer(productIn.featured_image, "large")}">`;
        }

        let html = "";

        // determine current alt tag and remove last letter
        let alt = productIn.correctVariant.featured_image.alt;
        alt = alt.substring(0, alt.length - 1);

        // loop over all images and find the one that matches the alt tag
        productIn.media.forEach(function (image) {
            // skip black list alt tags
            if (["YBACK", "RBACK", "WBACK", "BBACK", "WYBACK", "WRBACK"].includes(image.alt)) {
                return;
            }

            // check if alt tag matches
            if (image.alt.includes(alt) || image.alt.includes("LS")) {
                html += `<img class="collectionItemVisualSwiperImage swiper-slide" src="${imageResizer(image.src, "large")}">`;
            }
        });

        return html;
    }

    function collectionItemPrice() {
        let onSale = productIn.correctVariant.compare_at_price != null && productIn.correctVariant.compare_at_price > productIn.correctVariant.price;
        let HTML = `<div class="collectionItemPrice ${onSale ? "sale" : ""}">${price(productIn.correctVariant.price)}</div>`;
        if (onSale) {
            HTML += `<div class="collectionItemComparePrice">${price(productIn.correctVariant.compare_at_price)}</div>`;
        }
        return HTML;
    }

    let colorOptionIndex = -1;

    function collectionItemFlex2() {
        for (let i = 0; i < productIn.options.length; i++) {
            if (productIn.options[i].name === "Color" || productIn.options[i].name === "Gemstone") {
                // save index which is used to uped the collectionItemVariant label when the color swatch is changed
                colorOptionIndex = i;

                //print all color options
                let colors = "";
                let currentColor = productIn.correctVariant.options[i];

                // option name
                let optionName = "Color"
                if (productIn.options[i].name === "Gemstone") {
                    optionName = "Gemstone";
                }

                productIn.options[i].values.forEach(function (color) {
                    if (currentColor === color) {
                        colors += `<div class="active" option="${optionName}" value="${color}"></div>`;
                    } else {
                        colors += `<div option="${optionName}" value="${color}"></div>`;
                    }
                });

                return `
                    <div class="collectionItemSwatch">${colors}</div>
                    <div class="collectionItemVariant">${currentColor}</div>
                `;
            }
        }
        return "";
    }

    function collectionItemBadge() {
        // check if we're blocking out of stock purchases
        if (settings.allow_out_of_stock === false && productIn.correctVariant.inventory < 1) {
            return `<div class="collectionItemBadge soldOut">Sold Out</div>`;
        }

        // if there's a global sale, we show the sale icon for all products EXCEPT items that are already on sale
        if (globalDiscount != 1 && productIn.correctVariant.compare_at_price_real != null) {
            return `<div class="collectionItemBadge">Sale</div>`;
        }

        // if there's a compare at price and no inventory, they don't plan on re-stocking so it's sold out
        if (productIn.correctVariant.compare_at_price != null && productIn.correctVariant.inventory < 1) {
            return `<div class="collectionItemBadge soldOut">Sold Out</div>`;
        }

        // check for normal compare at price sale
        if (productIn.correctVariant.compare_at_price != null && productIn.correctVariant.compare_at_price > productIn.correctVariant.price) {
            return `<div class="collectionItemBadge">Sale</div>`;
        }

        // check for new product
        if (productIn.tags.includes("New")) {
            return `<div class="collectionItemBadge new">New</div>`;
        }

        return "";
    }

    function collectionItemCharity() {
        let collectionItemCharityHTML = "";

        // check for charity
        if (typeof productHandleToCharity !== 'undefined' && productHandleToCharity[productIn.handle]) {
            const charity = productHandleToCharity[productIn.handle];
            collectionItemCharityHTML = `
                <img class="collectionItemCharity" src="${charity.image}" alt="${charity} logo" style="width: ${charity.icon_width}px; height: ${charity.icon_height}px;">
            `;
        }

        return collectionItemCharityHTML;
    }

    function collectionItemQuickShip() {
        //this function only applies for the collection page since no other productIn data will have the inventory variable in the variants array.
        //the quick ship element will be in every product element; however, the inventory needs to be greater than 0 to be active OR it's a gift card
        let quickShipActive = "";
        let quickShipMessage = (productIn.handle == "gift-card") ? "Instant Delivery" : "In Stock";
        if (productIn.correctVariant.inventory > 0 || productIn.handle == "gift-card") {
            // long class adjusts the width since there is more text
            quickShipActive = (productIn.handle == "gift-card") ? "active giftCard" : "active";
        }
        return `<a class="collectionItemQuickShip quickShip ${quickShipActive}" href="${productIn.url}?variant=${productIn.correctVariant.id}"><i class="fa-solid fa-bolt-lightning"></i> ${quickShipMessage}</a>`;
    }

    // generate html
    let collectionItemHTML = `
        <div id="product${id}" class="collectionItem">
            <div class="collectionItemVisualWrapper">
                <a class="collectionItemVisual" href="${productIn.url}?variant=${productIn.correctVariant.id}">
                    ${collectionItemVisualHero()}
                    <div class="collectionItemVisualSwiper swiper">
                        <div class="swiper-wrapper">
                            ${collectionItemVisualSwiperSlides()}
                        </div>
                        <div class="collectionItemVisualSwiperScrollbar swiper-scrollbar"></div>
                    </div>
                </a>
            </div>
            <div class="collectionItemFlex1">
                <a class="collectionItemTitle" href="${productIn.url}?variant=${productIn.correctVariant.id}">${productIn.title}</a>
                <div class="collectionItemPriceInfo">
                    ${collectionItemPrice()}
                </div>
            </div>
            <div class="collectionItemFlex2">
                ${collectionItemFlex2()}
                <div class="collectionItemWishlist">
                    <svg class="collectionItemWishlistHeart" xmlns="http://www.w3.org/2000/svg" width="24" height="18.694" viewBox="0 0 24 18.694">
                        <g>
                        <path d="M12,18.694L2.083,11.231,0,6.662v-.2C0,2.899,2.899,0,6.462,0c2.347,0,4.407,1.258,5.538,3.136,1.132-1.878,3.191-3.136,5.538-3.136,3.563,0,6.462,2.899,6.462,6.462v.2l-2.083,4.569-9.917,7.463ZM3.568,10.038l8.432,6.345,8.432-6.345,1.718-3.768c-.101-2.456-2.131-4.423-4.611-4.423-2.545,0-4.615,2.071-4.615,4.615h-1.846c0-2.545-2.071-4.615-4.615-4.615C3.981,1.846,1.951,3.813,1.85,6.27l1.718,3.768Z" fill="#807c7c" stroke-width="0"/>
                        </g>
                    </svg>
                    <svg class="collectionItemWishlistHeartAdded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18.69">
                        <defs>
                            <style>
                                .cls-1 {
                                fill: #807c7c;
                                }
                            </style>
                        </defs>
                        <g>
                            <path class="cls-1" d="M12,18.69L2.08,11.23,0,6.66v-.2C0,2.9,2.9,0,6.46,0c2.35,0,4.41,1.26,5.54,3.14,1.13-1.88,3.19-3.14,5.54-3.14,3.56,0,6.46,2.9,6.46,6.46v.2l-2.08,4.57s-9.92,7.46-9.92,7.46Z"/>
                        </g>
                    </svg>
                    <div class="collectionItemWishlistHover">Add to wishlist</div>
                </div>
            </div>
            ${collectionItemBadge()}
            ${collectionItemCharity()}
            ${collectionItemQuickShip()}
        </div>
    `;

    // append or replace
    if (replace) {
        document.querySelector(selector).innerHTML = collectionItemHTML;
    } else {
        document.querySelector(selector).insertAdjacentHTML("beforeend", collectionItemHTML);
    }

    // get root element
    const rootElement = document.querySelector(`#product${id}`);

    // initialize swiper
    const visualSwiper = new Swiper(rootElement.querySelector(`.collectionItemVisualSwiper`), {
        slidesPerView: 1,
        scrollbar: {
            el: rootElement.querySelector(`.collectionItemVisualSwiperScrollbar`),
        },
        loop: true
    });

    // get current time
    const currentTime = new Date().getTime();

    // hide swiper
    let hideSwiper = false;

    // on slide change
    let swiperLock = 0;
    visualSwiper.on('slideChange', async function () {
        // must be more than 2 seconds since then initial load
        if (new Date().getTime() - currentTime < 1000) {
            return;
        }

        // exit if swiper is hidden
        if (hideSwiper) {
            hideSwiper = false;
            return;
        }

        // increment lock to prevent multiple calls
        const currentLock = ++swiperLock;

        //  active scrollbar with active class
        rootElement.querySelector(`.collectionItemVisualSwiperScrollbar`).classList.add("active");

        // wait 2 seconds
        await sleep(2000);

        // hide scrollbar
        if (currentLock === swiperLock) {
            rootElement.querySelector(`.collectionItemVisualSwiperScrollbar`).classList.remove("active");
        }
    });

    // Create an observer for scroll events to track visibility
    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(async (entry) => {
            // exit if visible
            if (entry.isIntersecting) {
                return;
            }

            // hide swiper
            hideSwiper = true;

            // When the swiper goes out of view, slide to the first image
            visualSwiper.slideToLoop(0);

            // remove active class from scrollbar
            rootElement.querySelector(`.collectionItemVisualSwiperScrollbar`).classList.remove("active");
        });
    });

    // observe the root element
    observer.observe(rootElement);

    //check for charities
    if (rootElement.querySelector(`.collectionItemCharity`)) {
        rootElement.querySelector(`.collectionItemCharity`).addEventListener("click", function () {
            document.querySelector(`#${productHandleToCharity[productIn.handle].id}`).classList.add("active");
        });
    }

    // event listener for color swatch
    rootElement.querySelectorAll(`.collectionItemSwatch > div`).forEach(function (element) {
        element.addEventListener("click", function () {
            // current color and variantTitle
            let currentColor = rootElement.querySelector(`.collectionItemSwatch > div.active`).getAttribute("value");
            let currentVariantTitle = productIn.correctVariant.title;

            // new color and variantTitle
            let newColor = this.getAttribute("value");
            let newVariantTitle = currentVariantTitle.replace(currentColor, newColor);

            // find new variant based off new variantTitle and must have a valid image
            const newVariant = productIn.variants.find(variant => variant.title === newVariantTitle && variant.featured_image);

            // skip if no new variant
            if (!newVariant) {
                return;
            }

            // update correct variant object
            productIn.correctVariant = newVariant;

            // re-render product
            appendProduct(`#product${id}`, productIn, true);
        });
    });

    //setup wishlist
    setupWishlist(rootElement.querySelector(`.collectionItemWishlist`), productIn);
}


let wishlist = [];
let wishlistDownloaded = false;

//download wishlist
function downloadWishlist() {
    if (customerID && !wishlistDownloaded) {

        let formData;
        formData = new FormData();
        formData.append("customerID", customerID);
        return fetch("https://api.aliweissjewelry.com/wishlist/pull.php", {
            method: "POST",
            body: formData
        }).then(function (data) {
            return data.json();
        }).then(function (data) {
            wishlist = data;
            wishlistDownloaded = true;
        });

    } else {
        return Promise.resolve()
    }
}

//setup wishlist
function setupWishlist(element, productIn) {
    //check if its active 
    if (wishlist.includes(productIn.handle)) {
        element.classList.add("active");
    }

    //add to wishlist on click
    element.addEventListener("click", function () {

        if (customerID) {

            if (this.classList.contains("active")) {

                formData = new FormData();
                formData.append("customerID", customerID);
                formData.append("productID", productIn.handle);
                fetch("https://api.aliweissjewelry.com/wishlist/remove.php", {
                    method: "POST",
                    body: formData
                }).then(function () {
                    element.classList.remove("active");
                })

            } else {

                formData = new FormData();
                formData.append("customerID", customerID);
                formData.append("productID", productIn.handle);
                fetch("https://api.aliweissjewelry.com/wishlist/push.php", {
                    method: "POST",
                    body: formData
                }).then(function () {
                    element.classList.add("active");
                    //before opening, need to update element
                    document.querySelector("#wishlistAddedImage").setAttribute("src", productIn.featured_image);
                    document.querySelector("#wishlistAddedTitle").textContent = productIn.title;
                    document.querySelector("#wishlistAddedPrice").innerHTML = `${price(productIn.price)}` + `<a href="/account?view=wishlist">View your wishlist</a>`;
                    document.querySelector("#wishlistAdded").classList.add("active");
                    //if it's on the product page and the sticky product bar is active we need to adjust the placement of the wishlist popup
                    if (window.location.pathname.includes("products") && document.querySelector("#productStickyBar").classList.contains("active")) {
                        document.querySelector("#wishlistAdded").classList.add("offset");
                    }
                    setTimeout(function () {
                        document.querySelector("#wishlistAdded").classList.remove("active");
                        document.querySelector("#wishlistAdded").classList.remove("offset");
                    }, 4000);
                })

            }

        } else {
            //open wishlist sign in modal
            document.querySelector("#wishlistModal").classList.add("active");
            document.querySelector("body").classList.add("noScroll");
            document.querySelector("#returnURL").value = window.location.href;
        }

    });

}


/*************
 * related product functin (models)
 */

// function for setting up images
function setRelatedProduct(relatedProduct) {
    // used to ceck if this variant is on this page or not
    let productVariantList = [];
    if (typeof product != 'undefined') {
        productVariantList = product.variants.map(variant => variant.id);
    }

    // set image
    document.querySelector("#relatedImage").src = `https://cdn.aliweissjewelry.com/models/${relatedProduct.image}`;

    // reset container
    document.querySelectorAll(".relatedProduct").forEach(function (element) {
        element.remove();
    })

    // append products
    let complete = 0;
    relatedProduct.products.forEach(function (item, index) {
        // create container so the order is respected
        document.querySelector("#relatedProducts").insertAdjacentHTML("beforeend", `<a class="relatedProduct"></a>`);

        downloadProduct(item.handle)
            .then(function (product) {
                // product equals false when we cannot retrive it (POS)
                if (product == false) {
                    return;
                }

                let variant = false;

                // find real matching variant based on ID
                for (let i = 0; i < product.variants.length; i++) {
                    if (product.variants[i].id == item.variant) {
                        variant = product.variants[i];
                    }
                }

                if (!variant) {
                    return;
                }

                // global discount if not a discount AND not already updated for sale
                // the AND is important since domain aliasing it would happen twice if called on same product
                if (globalDiscount != 1) {
                    if (variant.compare_at_price == null) {
                        variant.compare_at_price = variant.price;
                    }
                    variant.price *= globalDiscount;
                }

                // related price
                function relatedProductPrice() {
                    let onSale = variant.compare_at_price != null && variant.compare_at_price > variant.price;
                    let HTML = `
                            <div class="relatedProductPrice ${onSale ? "sale" : ""}">
                                <span>${price(Math.round(variant.price))}</span>
                                ${onSale ? `<s>${price(variant.compare_at_price)}</s>` : ""}
                            </div>
                        `;
                    return HTML;
                }

                // append related product
                document.querySelectorAll(".relatedProduct")[index].outerHTML = `
                    <a class="relatedProduct" href="${product.url}?variant=${variant.id}">
                        <img class="relatedProductImage length" src="${imageResizer(variant.featured_image.src, "large")}">
                        <div class="relatedProductInfo length">
                            <div class="relatedProductTitle">${product.title}</div>
                            ${relatedProductPrice()}
                        </div>
                        <div class="relatedProductArrow">
                            <i class="fa-light fa-arrow-right-long fa-sm"></i>
                        </div>
                    </a>
                `;

                // check if product appended is the same as the current product
                if (productVariantList.includes(variant.id)) {
                    document.querySelector(`.relatedProduct[href="${product.url}?variant=${variant.id}"]`).addEventListener("click", function (e) {
                        e.preventDefault();

                        // scroll to top
                        window.scroll({
                            top: 0,
                            behavior: "smooth"
                        })

                        // update active variant
                        setActiveVariant(variant.id);

                        // update product
                        updateProduct();
                    });
                }

                // increment compelte counter
                complete++;

                // update length class since some products may not have been retrived
                document.querySelectorAll(`#related .length`).forEach(function (element) {
                    element.removeAttribute("length");
                    element.setAttribute("length", complete);
                });
            })
    });
}

// on document load
document.addEventListener("DOMContentLoaded", function () {

    /****************************************** Modal ******************************************/

    //modal close
    document.querySelectorAll(".modal").forEach(function (element) {
        element.addEventListener("click", function (e) {
            if (e.target == this) {
                this.classList.remove("active");
                document.querySelector("body").classList.remove("noScroll");
            }
        });
    })

    //modal close
    //style only for mobile sort
    document.querySelectorAll(".modalExit:not(.styleOnly)").forEach(function (element) {
        element.addEventListener("click", function () {
            document.querySelector(".modal.active").classList.remove("active");
            document.querySelector("body").classList.remove("noScroll");
        });
    })

    /****************************************** Nav ******************************************/

    //this needs to work for both nav and cart to close
    document.querySelector("#pageCover").addEventListener("click", function () {
        closeNav();
        closeCart();
    });

    /*********************************************** nav *********************************************/

    //faq event listeners for each of the questions
    document.querySelectorAll(".faqItem").forEach(function (element) {
        element.addEventListener("click", function () {
            if (this.classList.contains("active")) {
                this.classList.remove("active");
                this.children[1].removeAttribute("style");
            } else {
                //check if there is a question already active, click on it
                if (document.querySelector(".faqItem.active")) {
                    document.querySelector(".faqItem.active").click();
                }
                this.classList.add("active");
                this.children[1].style.height = `${this.children[1].scrollHeight}px`;
            }
        });
    });

    //make all links open in a new tab in the FAQ item
    document.querySelectorAll(".faqItem a").forEach(function (element) {
        element.setAttribute("target", "_blank");
    });

    /*********************************************** just uno *********************************************/

        // Keeps checking until just uno element is found
    const bodyObserver = new MutationObserver(function () {
            if (document.querySelector("#ju_overlay")) {
                popupObserver.observe(document.querySelector("#ju_overlay"), {
                    childList: true,
                    attributes: true,
                    attributeFilter: ["style"]
                });
                bodyObserver.disconnect();
            }
        });
    bodyObserver.observe(document.querySelector("body"), {childList: true})


    const popupObserver = new MutationObserver(function () {
        let JUElement = document.querySelector("#ju_overlay");
        if (JUElement.style.display == "block") {
            document.querySelector("body").classList.add("noScroll");
        } else {
            document.querySelector("body").classList.remove("noScroll");
        }
    })

})

/***************************************** Time ******************************************/

const second = 1000;
const minute = second * 60;
const hour = minute * 60;
const day = hour * 24;

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}